import React, { useState } from "react";
import { AIRTABLE_URL_TECHNICIAN, AIRTABLE_HEADERS } from "./constants";

export default function TechnicianIssueForm() {
  const [technicianPhone] = useState(localStorage.getItem("technicianPhone") || "");
  const [issueCategory, setIssueCategory] = useState("");
  const [issueDescription, setIssueDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");
  const [showForm, setShowForm] = useState(false); // For showing form after "Raise Issue"
  const [hasPending, setHasPending] = useState(false);

  const generateTechIssueId = () => `T-${Math.floor(100000 + Math.random() * 900000)}`;

  const checkPendingIssue = async () => {
    try {
      const res = await fetch(AIRTABLE_URL_TECHNICIAN, { headers: AIRTABLE_HEADERS });
      const data = await res.json();
      const pending = data.records.some(
        (record) =>
          record.fields.technicianPhone?.trim() === technicianPhone.trim() &&
          record.fields.complaintStatus !== "Resolved"
      );
      setHasPending(pending);
      return pending;
    } catch (err) {
      console.error("Error checking pending issues", err);
      return false;
    }
  };

  const handleRaiseIssueClick = async () => {
    const pending = await checkPendingIssue();
    if (pending) {
      setStatus("❌ You already have a pending issue. You can still raise another if necessary.");
    } else {
      setStatus("");
    }
    setShowForm(true);
  };

  const handleSubmit = async () => {
    if (!issueCategory || !issueDescription) {
      alert("Please fill all fields");
      return;
    }

    setLoading(true);
    try {
      const issueId = generateTechIssueId();

      const newIssue = {
        fields: {
          issueId,
          technicianPhone,
          issueCategory,
          issueDescription,
          // ✅ Human-readable date format
          issueDateTime: new Date().toLocaleString(), // e.g., "8/30/2025, 2:53:57 PM"
          complaintStatus: "Pending"
        }
      };

      const res = await fetch(AIRTABLE_URL_TECHNICIAN, {
        method: "POST",
        headers: AIRTABLE_HEADERS,
        body: JSON.stringify(newIssue)
      });

      const result = await res.json();
      if (!res.ok) throw new Error(result?.error?.message || "Airtable POST failed");

      setStatus("✅ Issue submitted successfully!");
      setIssueCategory("");
      setIssueDescription("");
      setShowForm(false);
      setHasPending(false);
    } catch (err) {
      console.error(err);
      setStatus("❌ Failed to submit issue.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 30, maxWidth: 600, margin: "auto" }}>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <button
          onClick={() => (window.location.href = "/technician-home")}
          style={{
            position: "absolute",
            top: 10,
            right: 10,
            background: "none",
            border: "none",
            fontSize: 20,
            cursor: "pointer",
            color: "Black"
          }}
        >
          ✖
        </button>
      </div>

      <h2>🛠️ Technician Issue</h2>

      {!showForm && (
        <button
          onClick={handleRaiseIssueClick}
          style={{
            backgroundColor: "#007bff",
            color: "white",
            padding: "10px 20px",
            border: "none",
            borderRadius: 4,
            cursor: "pointer",
            marginBottom: 20
          }}
        >
          📝 Raise Issue
        </button>
      )}

      {showForm && (
        <>
          {hasPending && (
            <p style={{ color: "orange" }}>
              ⚠️ You have a pending issue. You can still raise another if necessary.
            </p>
          )}

          <input
            type="text"
            value={technicianPhone}
            readOnly
            style={{
              width: "100%",
              padding: 10,
              marginBottom: 10,
              backgroundColor: "#f0f0f0",
              border: "1px solid #ccc",
              color: "#555"
            }}
          />

          <select
            value={issueCategory}
            onChange={(e) => setIssueCategory(e.target.value)}
            style={{ width: "100%", padding: 10, marginBottom: 10 }}
          >
            <option value="">📋 Select Issue Category</option>
            <option value="Customer not paying">Customer not paying</option>
            <option value="Payment delayed">Payment delayed</option>
            <option value="Customer misbehaving">Customer misbehaving</option>
            <option value="Fake customer">Fake customer</option>
            <option value="Other">Other</option>
          </select>

          <textarea
            placeholder="📝 Issue Description"
            value={issueDescription}
            onChange={(e) => setIssueDescription(e.target.value)}
            style={{ width: "100%", padding: 10, marginBottom: 10 }}
          />

          <button
            onClick={handleSubmit}
            disabled={loading}
            style={{
              backgroundColor: "#007bff",
              color: "white",
              padding: "10px 20px",
              border: "none",
              borderRadius: 4,
              cursor: "pointer",
              marginBottom: 10
            }}
          >
            {loading ? "Submitting..." : "Submit Issue"}
          </button>
        </>
      )}

      <button
        onClick={() => (window.location.href = "/view-my-issues")}
        style={{
          backgroundColor: "#28a745",
          color: "white",
          padding: "10px 20px",
          border: "none",
          borderRadius: 4,
          cursor: "pointer",
          marginLeft: showForm ? 10 : 0
        }}
      >
        👁️ View My Issues
      </button>

      {status && <p style={{ marginTop: 15 }}>{status}</p>}
    </div>
  );
}
